import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastaService, ToastaConfig } from 'ngx-toasta';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { AppSettings } from '../../../../../app.settings';
import { Settings } from '../../../../../app.settings.model';
import { TipoToasta } from '../../../../../enums/Toasta.enum';
import { AppOAuthStore } from '../../../../../models/AppOAuthSotarge';
import { httpConnect } from '../../../../../services/httpConnect.service';
import { NotificationService } from '../../../../../services/Notification.service';
import { CatalagosConfig } from '../../../../../models/CatalogosConfig';
import { faCommentAlt, faMapMarkerAlt, faNotesMedical, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ServicioLlamada, ServicioUbicacion, ServicioAsignacion, ServicioComentario, ServicioTipoUnidad, ServicioLesionado, ServicioAntecedente, ServicioAntecedenteComentarios } from '../../../../../models/Socorros/Servicio';
import { FormBuilder, FormControl, FormControlName } from '@angular/forms';
import { UtilsService } from '../../../../../services/Utils.service';
import { GoogleMapSearch } from '../../../../../shared/google-map-search/googlemapsearch.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SocorrosPrioridad, SocorrosPrioridadPaciente } from '../../../../../models/Socorros/SocorrosPrioridad';
import { SocorrosTipoAtencion } from '../../../../../models/Socorros/SocorrosTipoAtencion';
import { EnumOperator, FieldValidator } from '../../../../../models/FieldValidator';
import { addMinutes } from 'date-fns'
import { setTimeout } from 'timers';
import { Comentario } from '../../../../../models/Shared/Comentario';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { DialogConfirmacion } from 'src/app/shared/dialogs/confirmacion/dialogConfirmacion.component';

@Component({
    selector: 'app-dialog-registro-llamada',
    templateUrl: '../../Views/Dialogs/dialogRegistroLlamada.component.html',
    styleUrls: [
        '../../Styles/servicios.component.scss',
        '../../../../../theme/styles/_common.scss'
    ],
    encapsulation: ViewEncapsulation.None
})

export class DialogRegistroLlamada implements OnInit {

    public prioridades : Array<SocorrosPrioridad> = new Array<SocorrosPrioridad>();
    public prioridadesPaciente : Array<SocorrosPrioridadPaciente> = new Array<SocorrosPrioridadPaciente>();
    public tiposAtencion : Array<SocorrosTipoAtencion> = new Array<SocorrosTipoAtencion>();

    public prioridadLesionado : SocorrosPrioridad;
    public connectSvc: httpConnect;
    public opciones : ToastaService;
    public configuraciones : ToastaConfig;
    public displayToasta : boolean = true;
    public settings: Settings;
    private connSvc: httpConnect;
    public folio : string = ''
    public _fechaRegistro : Date = new Date();
    public fechaRegistroStr : string = this._fechaRegistro.toLocaleDateString("fr-fr")
    public horaRegistro : string = this._fechaRegistro.toLocaleTimeString("fr-fr").substring(0, 5)

    public catConfig: CatalagosConfig = new CatalagosConfig();
    public nuevoComentario: string;
    public nuevoComentarioAntecedente: string;
    public nuevoComentarioPaciente: string;
    
    /* Sources cat-autocompletes */
    public municipioSelected : any = {};
    public parentescoSelected : any = {};
    public origenLlamadaSelected : any = {};
    public empresaSelected : any = {};
    public tipoProblematicaSelected : any = {};
    public claveServicioSelected : any = {};
    public municipioUbicacionSelected : any = {};

    /* Chiplist */
    public selectable   = true;
    public removable    = true;
    public addOnBlur    = true;
    public separatorKeysCodes: number[] = [ENTER, COMMA];
    public tiposUnidad  : any[] = [];
    public ctrlTipoUnidad   = new FormControl();
    public filteredTipoUnidad   : Observable<any>;
    @ViewChild('autoTipoUnidad') ACTipoUnidad   : MatAutocomplete;
    @ViewChild('TipoUnidadInput') tipoUnidadInput   : ElementRef<HTMLInputElement>;

    /*  Autocomplete de empresa */
    ctrlEmpresa = new FormControl();
    public filteredEmpresa : Observable<any>;
    
    /*  Autocomplete de tipo de problemática    */
    ctrlProblematica = new FormControl();
    public filteredTipoProblematica : Observable<any>;

    /*  Autocomplete solicitante    */
    public solicitanteSelected = {};
    ctrlSolicitante = new FormControl();
    public filteredSolicitante : Observable<any>;

    /*  Autocomplete teléfono   */
    public telefonoSelected = {};
    ctrlTelefono = new FormControl();
    public filteredTelefono : Observable<any>;


    /* Tipo de atención */
    public tipoAtencion : number = -1;

    public icons = {
        medicalNotes : faNotesMedical,
        delete : faTrash,
        addCircle : faPlusCircle,
        comment : faCommentAlt,
        ubicacion   : faMapMarkerAlt,
    }

    public servicio : ServicioLlamada;
    public servicioUbicacion : ServicioUbicacion;
    public servicioAsignacion : ServicioAsignacion;
    public servicioComentarios : Array<ServicioComentario> = new Array<ServicioComentario>();
    public servicioTipoUnidad : Array<ServicioTipoUnidad> = new Array<ServicioTipoUnidad>();
    public listadoServicio : Array<ServicioLlamada> = new Array<ServicioLlamada>();
    public lesionado : ServicioLesionado;
    public antecedente : ServicioAntecedente;
    public servicioAntecedenteComentarios : Array<ServicioAntecedenteComentarios> = new Array<ServicioAntecedenteComentarios>();
    public servicioComentariosPaciente : Array<ServicioComentario> = new Array<ServicioComentario>();
    public lesionados : Array<ServicioLesionado> = new Array<ServicioLesionado>();;


    public strCoordenadas : string;
    public referenciaLength : number = 255;

    /* Comentarios  */
    public servicioFbGroup = this.fb.group({
        comentario : '',
        comentarioAntecedente:'',
        comentarioPaciente :''
    })
    comentarios = [];
    comentarioObj = {
        comentario: "",
        id_registradopor : 0,
        registradopor : "",
        fecha_comentario : this.utilsSrv.GetLocalISODateTime(Date.now() + 43200000).slice(0,19)
    };

    public _id_perfil : number;
    public permisosBotones = {
        permisoLlamada : {id : 4, detalle : {}}
    }

    private limpiaCoordenadas : boolean = true;

    public showSections:boolean = false;
    public guardaOM:boolean = false;
    public paciente:string = "";
    public enfermedades_cirugias_previas:string = "";
    public medicamentos_ingiriendo:string = "";
    public eventos_previos:string = "";
    public prediagnostico:string = "";
    /*  Validador   */
    @ViewChild('acMunicipio') acMunicipio: ElementRef;
    @ViewChild('acSolicitante', {read: ElementRef}) acSolicitante : ElementRef;
    @ViewChild('acTelefono', {read: ElementRef}) acTelefono : ElementRef;
    @ViewChild('acEdad', {read: ElementRef}) acEdad : ElementRef;
    @ViewChild('acParentesco') acParentesco : ElementRef;
    @ViewChild('acOrigenLlamada') acOrigenLlamada : ElementRef;
    @ViewChild('acEmpresa', {read : ElementRef}) acEmpresa : ElementRef;
    @ViewChild('acProblematica', {read : ElementRef}) acProblematica : ElementRef;
    @ViewChild('acClaveServicio') acClaveServicio : ElementRef;
    @ViewChild('calle', {read : ElementRef}) calle : ElementRef;
    @ViewChild('entreCalles', {read : ElementRef}) entreCalles : ElementRef;
    @ViewChild('Nombre', {read : ElementRef}) Nombre : ElementRef;
    @ViewChild('acSexo', {read : ElementRef}) acSexo : ElementRef;
    @ViewChild('acPrioridad', {read : ElementRef}) acPrioridad : ElementRef;
    @ViewChild('riesgo', {read : ElementRef}) riesgo: ElementRef;

    @ViewChild('colonia', {read : ElementRef}) colonia : ElementRef; 
    @ViewChild('acMunicipioUbicacion') acMunicipioUbicacion : ElementRef;

    public requiredFields: Array<FieldValidator> = [];
    public requiredFieldsTipoAtencion: Array<FieldValidator> = [];
    public requiredFieldsOrientacion: Array<FieldValidator> = [];
    public emptyRequiredFields: Array<any> = [];
    public _saved: boolean = false;
    constructor( public httpConn: httpConnect,
        public dialogRef: MatDialogRef<DialogRegistroLlamada>,
        private toastaService: ToastaService,
        private toastaConfig: ToastaConfig,
        private Notificacion : NotificationService,
        public appSettings : AppSettings,
        public myStorage: AppOAuthStore, 
        private fb: FormBuilder,
        public utilsSrv: UtilsService,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any){
            this.connectSvc     = this.httpConn;
            this.settings = this.appSettings.settings;
            this.connSvc = this.httpConn;
            this.toastaConfig.theme = "default";
            this.toastaConfig.timeout = 7000;
            this.toastaConfig.position = "bottom-right";
            this.configuraciones = this.toastaConfig;
            this.opciones = this.toastaService;
            this.Notificacion =  new NotificationService(this.opciones, this.configuraciones);
            this.folio = data.folio

            const id_usuario = parseInt(this.myStorage.getItem("id_usuario"))
            const usuario = this.myStorage.getItem("nombre_personal")
            this._id_perfil =  parseInt(this.myStorage.getItem('id_perfil'));
            this.servicio = new ServicioLlamada(id_usuario, usuario);
            this.listadoServicio.unshift(this.servicio);

            this.comentarioObj.id_registradopor = id_usuario;
            this.comentarioObj.registradopor = usuario;

            
        }

    ngOnInit(): void {
        this.servicioUbicacion = new ServicioUbicacion();
        this.servicioAsignacion = new ServicioAsignacion();
        this.lesionado = new ServicioLesionado();
        this.antecedente = new ServicioAntecedente();
        this.strCoordenadas = [this.servicioUbicacion.latitud.toString(), this.servicioUbicacion.longitud.toString()].join(", ")
        this._inicializaAC()
        this.lesionados.unshift(this.lesionado);
        this.settings.loadingSpinnerProcess = true;
        forkJoin([
            this._getPrioridad(),
            this._getTiposAtencion(),
            this._getPermisos(this.permisosBotones.permisoLlamada.id)
        ]).subscribe(res => {
            this.prioridades = [...res[0]]
            this.tiposAtencion = [...res[1]]

            this.permisosBotones.permisoLlamada.detalle = {...res[2][0]};
        }, error => this.Notificacion.ShowToasta(error.error.Message, TipoToasta.ERROR))
        .add(() => this.settings.loadingSpinnerProcess = false)

        if(this.data.id_servicio != null ){
            this.servicio.id_servicio = this.data.id_servicio;
            this.GetServicioLlamada()
        }
        else if (this.data.id_evento != null) {
            this.GetInfoEvento(this.data.id_evento);
        }
        
    }

    private GetInfoEvento(id) {
        this.settings.loadingSpinnerProcess = true;
        let params = {
            idEvento: id
        }
        this.connectSvc.postAPI("EventosEspeciales", "ObtieneEventoDetalle", params)
        .subscribe(result => {
            this.limpiaCoordenadas = false;
            let evento = result.response;
            this.servicio.id_municipio = evento.eventoDetalle.id_municipio;
            this.servicio.municipio = evento.eventoDetalle.municipio;
            this.servicioUbicacion.calle = evento.eventoDetalle.calle;
            this.servicioUbicacion.exterior = evento.eventoDetalle.no_ext;
            this.servicioUbicacion.colonia = evento.eventoDetalle.colonia;
            this.servicioUbicacion.interior = evento.eventoDetalle.no_int;
            this.servicioUbicacion.id_municipio = evento.eventoDetalle.id_municipio;
            this.servicioUbicacion.municipio = evento.eventoDetalle.municipio;
            this.servicioUbicacion.latitud = evento.eventoDetalle.ubicacion.split(", ")[0];
            this.servicioUbicacion.longitud = evento.eventoDetalle.ubicacion.split(", ")[1];
            this.servicioUbicacion.referencia = evento.eventoDetalle.referenciaubicacion;
            this.municipioSelected = {id : this.servicio.id_municipio, value : this.servicio.municipio};
            this.municipioUbicacionSelected = {id : this.servicioUbicacion.id_municipio, value : this.servicioUbicacion.municipio};
            this.strCoordenadas = [this.servicioUbicacion.latitud.toString(), this.servicioUbicacion.longitud.toString()].join();
            this.limpiaCoordenadas = true;
        }, error => {
            this.Notificacion.ShowToasta(error.error.message, TipoToasta.ERROR);
        })
        .add(() => this.settings.loadingSpinnerProcess = false)
    }

    _inicializaAC(){
        this.filteredTipoUnidad = this.ctrlTipoUnidad.valueChanges
        .pipe(
            startWith(''),
            switchMap(value => typeof value === 'string' ? this._getAC('transportes_tipo_unidad', value) : [])
        );

        this.filteredEmpresa = this.ctrlEmpresa.valueChanges
        .pipe(
            startWith(null),
            switchMap(value => typeof value === 'string' ? this._getACEmpresa(value) : [])
        );

        this.filteredTipoProblematica = this.ctrlProblematica.valueChanges
        .pipe(
            startWith(null),
            switchMap(value => typeof value === 'string' ? this._getACTipoProblematica(value) : [])
        )

        // Solicitante
        this.filteredSolicitante = this.ctrlSolicitante.valueChanges
        .pipe(
            startWith(null),
            switchMap(value => typeof value === 'string' ? this._getSolicitante(value) : [])
        )

        // Teléfono
        this.filteredTelefono = this.ctrlTelefono.valueChanges
        .pipe(
            startWith(null),
            switchMap(value => typeof value === 'string' ? this._getSolicitante(value) : [])
        )
    }

    public MostrarDialogConfirmaAgregar(type:string) {

        if(type == "paciente"){
            if (!this.nuevoComentario || this.nuevoComentario.length == 0) {
                this.Notificacion.ShowToasta("No se ha capturado ningún comentario. Favor de verificar", TipoToasta.ADVERTENCIA)
                return;
            } 
        }

        if(type == "antecedentes"){
            if (!this.nuevoComentarioAntecedente || this.nuevoComentarioAntecedente.length == 0) {
                this.Notificacion.ShowToasta("No se ha capturado ningún comentario. Favor de verificar", TipoToasta.ADVERTENCIA)
                return;
            }
        }
        if(type == "OMPaciente"){
            if (!this.nuevoComentarioPaciente || this.nuevoComentarioPaciente.length == 0) {
                this.Notificacion.ShowToasta("No se ha capturado ningún comentario. Favor de verificar", TipoToasta.ADVERTENCIA)
                return;
            } 
        }

        

        let dialogRef = this.dialog.open(DialogConfirmacion, {
            data: {
                titulo  : 'Agregar Comentario',
                mensaje : "¿Desea registrar el comentario?",
                tipo    : 5,
            },
              disableClose: true,
          });
          dialogRef.afterClosed().subscribe(result => {
              this.displayToasta = true;
              if (result.confirm){
                if(type == "paciente"){
                    this.agregarComentario(); 
                }
                if(type == "antecedentes"){
                    this.agregarComentarioAntecedente()
                }
                if(type == "OMPaciente"){
                    this.agregarComentarioPaciente()
                }
              }
          });
    }


    agregarComentario() {

        let fecha = this.utilsSrv.GetLocalISODateTime(Date.now()).split('T');
        let comentario = new ServicioComentario(
            this.servicio.id_servicio,
            fecha[0] + ' ' + fecha[1].substring(0, 8), 
            Number(this.myStorage.getItem('id_usuario')), 
            this.myStorage.getItem("nombre_personal"));
            
          comentario.comentario = this.nuevoComentario;
          this.servicioComentarios.unshift(comentario);
          this.servicioFbGroup.get('comentario').setValue('');
          this.nuevoComentario = null;
    }

    agregarComentarioAntecedente(){

        
        let fecha = this.utilsSrv.GetLocalISODateTime(Date.now()).split('T');         
        let comentario = new ServicioAntecedenteComentarios(
            this.antecedente.id_servicio_antedecente, 
            fecha[0] + ' ' + fecha[1].substring(0, 8), 
            Number(this.myStorage.getItem('id_usuario')), 
            this.myStorage.getItem("nombre_personal"));
          comentario.comentario = this.nuevoComentarioAntecedente;
          this.servicioAntecedenteComentarios.unshift(comentario);
          this.servicioFbGroup.get('comentarioAntecedente').setValue('');
          this.nuevoComentarioAntecedente = null;

    }

    
    agregarComentarioPaciente(){

        let fecha = this.utilsSrv.GetLocalISODateTime(Date.now()).split('T');
        let comentario = new ServicioComentario(
            this.servicio.id_servicio,
            fecha[0] + ' ' + fecha[1].substring(0, 8), 
            Number(this.myStorage.getItem('id_usuario')), 
            this.myStorage.getItem("nombre_personal"));
            
          comentario.comentario = this.nuevoComentarioPaciente;
          this.servicioComentariosPaciente.unshift(comentario);
          this.servicioFbGroup.get('comentarioPaciente').setValue('');
          this.nuevoComentarioPaciente = null;
    }

    eliminaComentarioPaciente(addedItem) {
        this.servicioComentariosPaciente.splice(addedItem, 1);
    }

    eliminaComentarioAntecedente(addedItem) {
        this.servicioAntecedenteComentarios.splice(addedItem, 1);
    }

    eliminaComentario(addedItem) {
        this.servicioComentarios.splice(addedItem, 1);
    }

    buscarGoogleMaps() {
        this.servicioUbicacion.id_municipio = this.municipioUbicacionSelected.id;
        this.servicioUbicacion.municipio = this.municipioUbicacionSelected.value;
        let dialogRef = this.dialog.open(GoogleMapSearch, {
          data: this.servicioUbicacion,
          width: '100%'
        });
    
        dialogRef.afterClosed()
          .subscribe(result => {
            if (result !== undefined) {
              this.servicioUbicacion = result;
              this.municipioUbicacionSelected = {id: result.id_municipio, value: result.municipio}
              this.servicioUbicacion.exterior = result.exterior; 

              this.strCoordenadas = this.servicioUbicacion.latitud.toString() + ', ' + this.servicioUbicacion.longitud.toString();
            }
            // console.log(this.servicioUbicacion);
          });
    }

    Selected(ctr: string, event: MatAutocompleteSelectedEvent): void {
        switch (ctr) {
            case 'ctrlTipoUnidad':
                if((this.tiposUnidad.length + 1) <= this.servicioAsignacion.cant_unidades){
                    this.tiposUnidad.push(event.option.value)
                    this.tipoUnidadInput.nativeElement.value = '';
                    this.ctrlTipoUnidad.setValue('');
                }else{
                    this.Notificacion.ShowToasta("No es posible agregar este tipo de unidad. El máximo permitido es " + this.servicioAsignacion.cant_unidades.toString() + ' tipos de unidad.', TipoToasta.ADVERTENCIA)
                }
                break;
            default:
                break;
        }
    }

    Add(ctr: string,input: MatChipInputEvent): void {
        switch (ctr) { 
            case 'ctrlTipoUnidad':
                if (!this.ACTipoUnidad.isOpen) input.chipInput!.clear();
                break;        
            default:
                break;
        }
        
    }

    Remove(ctr: string, e: any): void {
        switch (ctr) {
            case 'ctrlTipoUnidad':
                let tu = this.tiposUnidad.map(ti => ti.id).indexOf(e.id);
                if ( tu >= 0) this.tiposUnidad.splice(tu, 1);
                break;
            default:
                break;
        }
    }

    _getAC(catalogo : string, value : string , padreId? : number ) : Observable<any>{
        if( value.length < 2 ) return of();
        return this.connectSvc.postAPI('General', 'ACCatalogos_ConsultaXDesc', {catalogo : catalogo, value : value, padreId: padreId ? padreId : 0 })
        .pipe(
           map(res => res.response, catchError(err => throwError(err)))
        )
    }



    SetPrioridad(prioridad : any,patient:ServicioLesionado = null){          
    

        // this.lesionados[index].id_prioridad = prioridad.id_prioridad;          
        this.servicio.id_prioridad = prioridad.id_prioridad;
        
        if(patient != null)
            patient.id_prioridad = prioridad.id_prioridad
        // let element = document.getElementById('btn'+prioridad.descripcion+index);

            // // quita el color de fondo a todos los elementos
            // this.prioridades.forEach(p => {
            //     let e = document.getElementById("btn"+p.descripcion+index);
            //     e.style.backgroundColor = "";
            //     e.style.color = "#" + p.color_etiqueta;
            // });

            


            // let lesionados : Array<ServicioLesionado> = new Array<ServicioLesionado>();
            // lesionados.unshift(this.lesionado);
            // this.lesionados = lesionados;

 
            // element.style.backgroundColor = "#" + prioridad.color_etiqueta
            // element.style.color = "#" + prioridad.color_texto;


    }

    SetPrioridadPaciente(prioridad : any){
        let element = document.getElementById('btn-ante-'+prioridad.descripcion);
        this.lesionado.id_prioridad = prioridad.id_prioridad;

        //quita el color de fondo a todos los elementos
        this.prioridades.forEach(p => {
            let e = document.getElementById("btn-ante-"+p.descripcion);
            e.style.backgroundColor = "";
            e.style.color = "#" + p.color_etiqueta;
        });

        element.style.backgroundColor = "#" + prioridad.color_etiqueta
        element.style.color = "#" + prioridad.color_texto;

        this.prioridadLesionado = prioridad;

    }

    _getPrioridad() : Observable<any>{
        return this.connectSvc.postAPI('ServicioLlamada', 'ListSocorrosPrioridad', null)
        .pipe(
            map(res => res.success ? res.response : throwError(res.message), error => throwError(error))
        )
    }

    _getTiposAtencion() : Observable<any>{
        return this.connSvc.postAPI('ServicioLlamada', 'ListSocorrosTipoAtencion', null)
        .pipe(
            map(res => res.success ? res.response : throwError(res.message), error => throwError(error))
        )
    }

    _getACEmpresa(value : string) : Observable<any>{
        return this.connSvc.postAPI('ServicioLlamada', 'GetACEmpresa', {Value : value})
        .pipe(
            map(res => res.response, error => throwError(error))
        )
    }

    _getACTipoProblematica(value : string) : Observable<any>{
        return this.connSvc.postAPI('ServicioLlamada', 'GetACTipoProblematica', {Value : value})
        .pipe(
            map(res => res.response, error => throwError(error))
        )
    }

    SetServicioLlamada(){
        this.servicioTipoUnidad = new Array<ServicioTipoUnidad>();
        this.servicio.id_municipio = this.municipioSelected.id;
        this.servicio.id_origen_llamada = this.origenLlamadaSelected.id;
        this.servicio.id_clave_servicio = this.claveServicioSelected.id;
        this.servicio.id_origen_llamada = this.origenLlamadaSelected.id;
        this.servicio.id_parentesco = this.parentescoSelected.id;
        this.servicio.id_sexo = this.lesionados[0].id_sexo;
        this.servicio.edad = this.lesionados[0].edad;
        this.servicio.meses = this.lesionados[0].meses;
        /*  Ubicación   */
        this.servicioUbicacion.id_municipio = this.municipioUbicacionSelected.id;
        //pendiente: número exterior e interior

        /*  Tipo de unidad    */
        if(this.tiposUnidad.length > 0){
            let id_servicio_asignacion = this.servicioAsignacion.id_servicio_asignacion;
            this.tiposUnidad.forEach(tu => this.servicioTipoUnidad.push(new ServicioTipoUnidad(id_servicio_asignacion, tu.id)))
        }

        /*  Valida si no está seteado el id_contacto   */
        if(this.servicio.id_contacto == 0 && this.ctrlSolicitante.value != null && typeof this.ctrlSolicitante.value !== 'object' && this.ctrlSolicitante.value.toString().trim() != ''){
            this.servicio.id_contacto = -1;
            this.servicio.contacto = this.ctrlSolicitante.value.toString().trim();
        }

        if(this.servicio.telefono == '' && this.ctrlTelefono.value != null && typeof this.ctrlTelefono.value !== 'object' && this.ctrlTelefono.value.toString().trim()){
            this.servicio.telefono = this.ctrlTelefono.value.toString().trim();
        }

        this._setACSourcesContacto();

        if(this.servicio.id_tipo_atencion == 3 || this.servicio.id_tipo_atencion == 2){
            // this.servicio.id_municipio = this.servicio.id_municipio == undefined ? 0 : this.servicio.id_municipio;
            // this.servicio.id_contacto = this.servicio.id_contacto == undefined ? 0 : this.servicio.id_contacto;
            // this.servicio.contacto = this.servicio.contacto == undefined ? 'Sin Asignar' : this.servicio.contacto;
            // this.servicio.telefono = this.servicio.telefono == undefined ? '' : this.servicio.telefono;
            // this.servicio.id_parentesco = this.servicio.id_parentesco == undefined ? 0 : this.servicio.id_parentesco;
            // this.servicio.parentesco = this.servicio.parentesco == undefined ? 'Sin Asignar' : this.servicio.parentesco;
            this._setACSourcesContacto();
            // this.servicio.id_origen_llamada = this.servicio.id_origen_llamada == undefined ? 0 : this.servicio.id_origen_llamada;

            // this.servicio.id_problematica = this.servicio.id_problematica == undefined ? 0 : this.servicio.id_problematica;
            // this.servicio.problematica = this.servicio.problematica == undefined ? 'Sin Asignar' : this.servicio.problematica;
            this.servicio.id_clave_servicio = this.servicio.id_clave_servicio == undefined ? 0 : this.servicio.id_clave_servicio;
            this.servicio.clave_servicio = this.servicio.clave_servicio == undefined ? 'Sin Asignar' : this.servicio.clave_servicio;

            this.servicioUbicacion.calle = this.servicioUbicacion.calle == undefined ? '' : this.servicioUbicacion.calle;
            this.servicioUbicacion.entrecalles = this.servicioUbicacion.entrecalles == undefined ? '' : this.servicioUbicacion.entrecalles;
            this.servicioUbicacion.colonia = this.servicioUbicacion.colonia == undefined ? '' : this.servicioUbicacion.colonia;
            this.servicioUbicacion.id_municipio = this.servicioUbicacion.id_municipio == undefined ? 0 : this.servicioUbicacion.id_municipio;
            this.servicio.id_prioridad = this.servicio.id_prioridad == 0 ? 1 : this.servicio.id_prioridad;
            this.lesionados[0].id_prioridad = this.servicio.id_prioridad;
            const prioridad = this.prioridades.find(prioridad => prioridad.id_prioridad == this.servicio.id_prioridad);
            if (prioridad != undefined) {
                this.SetPrioridad(prioridad);
                // this.SetPrioridadPaciente(prioridad);
            }

            if(this.CheckRequiredFieldsTipoAtencion().length > 0){
                this.Notificacion.ShowToasta('Favor de capturar los campos requeridos', TipoToasta.ERROR);
                return;
            }
            

           
        }else{
        /*  Verifica los campos requeridos  */
        if(this.CheckRequiredFields().length > 0){
            this.Notificacion.ShowToasta('Favor de capturar los campos requeridos', TipoToasta.ERROR);
            return;
        }

        for (let index = 0; index < this.lesionados.length; index++) {
            const element = this.lesionados[index];
            if(element.id_prioridad == null){
                this.Notificacion.ShowToasta('Favor de capturar los campos requeridos', TipoToasta.ERROR);
                return;
            }
        }
        }

        // this.servicio.fecha_creacion =  addMinutes(this.servicio.fecha_creacion, - (this.servicio.fecha_creacion.getTimezoneOffset()))
        // this.servicio.fecha_registro = addMinutes(new Date(), - (new Date().getTimezoneOffset()))
        let _fecha = this.utilsSrv.GetLocalISODateTime(Date.now()).slice(0, 19);
        //this.servicio.fecha_creacion = _fecha;
        this.servicio.fecha_creacion = this.utilsSrv.GetLocalISODateTime(this.servicio.fecha_creacion).slice(0,19);
        this.servicio.fecha_registro = _fecha;

        this.settings.loadingSpinnerProcess = true;
        this._setServicioLlamada()
        .subscribe(res => {
            this.Notificacion.ShowToasta('Éxito al guardar.', TipoToasta.EXITO);
            this.servicio.id_servicio = res[0].id_servicio;
            this._saved = true;
            this.GetServicioLlamada()
        }, error => this.Notificacion.ShowToasta(error.error.Message, TipoToasta.ERROR))
        .add(() => this.settings.loadingSpinnerProcess = false)
        // console.log('Llamada ', this.servicio);
        // console.log('Ubicacion ', this.servicioUbicacion);
        // console.log('Asignacion ', this.servicioAsignacion);
        // console.log('TipoUnidad ', this.servicioTipoUnidad)
        // console.log('Comentarios ', this.servicioComentarios);

        
    }

    SetServicioOrientacionMedica(){

         /*  Verifica los campos requeridos  */
         if(this.CheckRequiredFieldsOrientacion().length > 0){
            this.Notificacion.ShowToasta('Favor de capturar los campos requeridos', TipoToasta.ERROR);
            return;
        }
        this.servicio.id_sexo = this.lesionado.id_sexo;
        this.servicio.edad = this.lesionado.edad;
        this.servicio.meses = this.lesionado.meses;
        this.servicioComentarios = this.servicioComentariosPaciente;
        this.guardaOM = true;

        let _fecha = this.utilsSrv.GetLocalISODateTime(Date.now()).slice(0, 19);
        //this.servicio.fecha_creacion = _fecha;
        this.servicio.fecha_creacion = this.utilsSrv.GetLocalISODateTime(this.servicio.fecha_creacion).slice(0,19);
        this.servicio.fecha_registro = _fecha;

        //this.showRegistroLlamada(true);
        this._setServicioLlamada()
        .subscribe(res => {
            this.Notificacion.ShowToasta('Éxito al guardar.', TipoToasta.EXITO);
            this.servicio.id_servicio = res[0].id_servicio;
            this._saved = true;
            this.GetServicioLlamada()
        }, error => this.Notificacion.ShowToasta(error.error.Message, TipoToasta.ERROR))
        .add(() => this.settings.loadingSpinnerProcess = false)
    }

    _setServicioLlamada() : Observable<any>{
        const params = {
            Llamada : this.servicio,
            Ubicacion : this.servicioUbicacion,
            Comentarios : this.servicioComentarios,
            Asignacion : this.servicioAsignacion,
            TipoUnidad : this.servicioTipoUnidad,
            Lesionados: this.lesionados,
            Antecedente: this.antecedente,
            AntecedenteComentarios :this.servicioAntecedenteComentarios,
            ComentariosPaciente:this.servicioComentariosPaciente,
            Evento : this.data.id_evento,
            Tripulacion : [{id_tripulacion : this.data.id_tripulacion}]
        }
        return this.connSvc.postAPI('ServicioLlamada', 'SetSocorrosRegistroLlamada', params)
        .pipe(
            map(res => res.success ? res.response : throwError(res.message), error => throwError(error))
        )
    }

    public agregarPaciente(){
        // let newServicio =  new ServicioLlamada(this.comentarioObj.id_registradopor, this.comentarioObj.registradopor)
        // this.listadoServicio.unshift(newServicio);
        let paciente = new ServicioLesionado();
        this.lesionados.unshift(paciente);      

    }

    public eliminarPaciente(paciente:number){
        if(this.lesionados.length > 1){
            this.lesionados.splice(paciente,1);   
        }else{
            this.Notificacion.ShowToasta('Debe de haber por lo menos 1 paciente agregado. Favor de validar.', TipoToasta.ADVERTENCIA);
        }
    }

    GetServicioLlamada(){
        this.settings.loadingSpinnerProcess = true;
        this._getServicioLlamada().subscribe(res => {
            this.servicio = res.llamada;
            // this.lesionado.edad = this.servicio.edad;
            // this.lesionado.meses = this.servicio.meses;
            // this.lesionado.sexo = this.servicio.id_sexo;
            this.servicioAsignacion = res.asignacion;
            this.servicioComentarios = res.comentarios;
            this.servicioComentariosPaciente = res.comentarios;
            this.limpiaCoordenadas = false;
            this.servicioUbicacion = res.ubicacion;
            this.servicioTipoUnidad = res.tipoUnidad;
            if(res.lesionado != null){
                this.lesionados = res.lesionado;

                this.lesionado = res.lesionado[0];
            }
            if(res.antecedente != null){
                this.antecedente = res.antecedente;
            }
            
            if(res.antecedenteComentarios.length > 0){
                this.servicioAntecedenteComentarios = res.antecedenteComentarios;
            }
            this.servicio.fecha_creacion = new Date(this.servicio.fecha_creacion);
            this.servicio.fecha_registro = new Date(this.servicio.fecha_registro);

            this.tiposUnidad = this.servicioTipoUnidad.map(tu => ({id : tu.id_tipo_unidad, value : tu.tipo_unidad}))
            this._setACSources();
            this.limpiaCoordenadas = true;

        }, error => this.Notificacion.ShowToasta(error.error.Message, TipoToasta.ERROR))
        .add(() => this.settings.loadingSpinnerProcess = false)
    }

    _getServicioLlamada() : Observable<any>{
        return this.connSvc.postAPI('ServicioLlamada', 'GetServicioLlamada', {Servicio : this.servicio.id_servicio})
        .pipe(
            map(res => res.success ? res.response : throwError(res.message), error => throwError(error))
        )
    }

    _setACSources(){
        /*  Datos solicitante   */
        this.municipioSelected = {id : this.servicio.id_municipio, value : this.servicio.municipio};
        this.origenLlamadaSelected = {id : this.servicio.id_origen_llamada, value : this.servicio.origen_llamada};
        this.empresaSelected = {id_empresa : this.servicio.id_empresa, descripcion : this.servicio.empresa};
        this.ctrlEmpresa.setValue(this.empresaSelected);
        this._setACSourcesContacto();

        /* Datos del servicio   */
        this.tipoProblematicaSelected = {id_problematica : this.servicio.id_problematica, problematica : this.servicio.problematica};
        this.ctrlProblematica.setValue(this.tipoProblematicaSelected);
        this.claveServicioSelected = {id : this.servicio.id_clave_servicio, value : this.servicio.clave_servicio};

        if (this.servicioUbicacion) { /*  Ubicación del servicio  */            
            this.municipioUbicacionSelected = {id : this.servicioUbicacion.id_municipio, value : this.servicioUbicacion.municipio};
            this.strCoordenadas = [this.servicioUbicacion.latitud.toString(), this.servicioUbicacion.longitud.toString()].join();
        }


        const prioridad = this.prioridades.find(prioridad => prioridad.id_prioridad == this.servicio.id_prioridad);
        if (prioridad != undefined) {
            this.SetPrioridad(prioridad);
            // this.SetPrioridadPaciente(prioridad);
        }
        
    }

    _setACSourcesContacto(){
        //Solicitante
        this.solicitanteSelected = {id_contacto : this.servicio.id_contacto, nombre : this.servicio.contacto}
        this.ctrlSolicitante.setValue(this.solicitanteSelected)
        //teléfono
        this.ctrlTelefono.setValue({telefono : this.servicio.telefono});
        this.parentescoSelected = {id : this.servicio.id_parentesco, value : this.servicio.parentesco}
    }

    /*  Display empresa */
    displayAC(o? : any) : string | undefined{
        return o? o.descripcion : undefined;
    }

    SetEmpresa(event : any,del:boolean = true){

        if(del){
            this.empresaSelected = event;
            this.servicio.id_empresa = event.id_empresa;
            this.servicio.empresa = event.descripcion;
            this.servicio.convenio = event.convenio;
        }else{            
            this.servicio.convenio = del;
            if(event.srcElement.value.length == 0){
                this.empresaSelected = {};
                this.servicio.id_empresa = 0;
                this.servicio.empresa = 'SIN ASIGNAR';
            }
        }
      
    }

    /*  Display tipo problematica   */
    displayACTipoProblematica(tp? : any) : string | undefined{
        return tp ? tp.problematica : undefined;
    }

    SetTipoProblematica(event : any){
        this.servicio.id_problematica = event.id_problematica;
        this.servicio.problematica = event.problematica;
        this.servicio.id_motivo_atencion = event.id_motivo_atencion;
        this.servicio.motivo_atencion = event.motivo_atencion;
    }

    displayACTelefono = (t? : any) : string | undefined => t? t.telefono : undefined;

    /*  Display solicitante */
    displayACSolicitante(s? : any) : string | undefined{
        return s? s.nombre : undefined;
    }

    SetSolicitante(event : any){
        this.servicio.id_contacto = event.id_contacto;
        this.servicio.contacto = event.nombre;
        this.servicio.telefono = event.telefono;
        this.servicio.id_parentesco = event.id_parentesco;
        this.servicio.parentesco = event.parentesco;

        this._setACSourcesContacto()
    }

    _getSolicitante(value : string) : Observable<any>{
        return this.connSvc.postAPI('ServicioLlamada', 'GetACContactoParentesco', {Value : value})
        .pipe(
            map(res => res.response, error => throwError(error))
        )
    }

    setMeses(event : any){
        this.servicio.meses = event > 0 ? 0 : this.servicio.meses;
    }

    public showRegistroLlamada(value:boolean){
        /*Si se selecciona la opcion de orientación médica se resetea la variable de listado de lesionados*/
        let lesionados : Array<ServicioLesionado> = new Array<ServicioLesionado>();
        lesionados.unshift(this.lesionado);
        this.lesionados = lesionados;
        this.showSections = value;     
        
    }

    

    /*  Validador   */
    private LoadRequiredFields() {
        this.requiredFields = [
            new FieldValidator('id', this.municipioSelected, this, 'acMunicipio', true),
            new FieldValidator('id_contacto', this.solicitanteSelected, this, 'acSolicitante', true, EnumOperator.Equals, [0]),
            new FieldValidator('telefono', this.servicio, this, 'acTelefono', true, EnumOperator.Equals, ['']),
            new FieldValidator('id', this.parentescoSelected, this, 'acParentesco', true),
            new FieldValidator('id', this.origenLlamadaSelected, this, 'acOrigenLlamada', true),
            //new FieldValidator('id_empresa', this.servicio, this, 'acEmpresa', true, EnumOperator.Equals, [0]),
            new FieldValidator('id_problematica', this.servicio, this, 'acProblematica', true, EnumOperator.Equals, [0]),
            new FieldValidator('id', this.claveServicioSelected, this, 'acClaveServicio', true),
            new FieldValidator('calle', this.servicioUbicacion, this, 'calle', true, EnumOperator.Equals, ['']),
            new FieldValidator('entrecalles', this.servicioUbicacion, this, 'entreCalles', true, EnumOperator.Equals, ['']),
            new FieldValidator('colonia', this.servicioUbicacion, this, 'colonia', true, EnumOperator.Equals, ['']),
            new FieldValidator('id', this.municipioUbicacionSelected, this, 'acMunicipioUbicacion', true),
            new FieldValidator('edad', this.servicio, this, 'acEdad', true, EnumOperator.Equals, ['']),
            //new FieldValidator('id_sexo', this.servicio, this, 'acSexo', true, EnumOperator.Equals, [''])

        ]
    }


    private LoadRequiredFieldsTipoAtencion() {
        this.requiredFieldsTipoAtencion = [
            new FieldValidator('id', this.municipioSelected, this, 'acMunicipio', true),
            new FieldValidator('id_contacto', this.solicitanteSelected, this, 'acSolicitante', true, EnumOperator.Equals, [0]),
            new FieldValidator('telefono', this.servicio, this, 'acTelefono', true, EnumOperator.Equals, ['']),
            new FieldValidator('id', this.parentescoSelected, this, 'acParentesco', true),
            new FieldValidator('id', this.origenLlamadaSelected, this, 'acOrigenLlamada', true),
            //new FieldValidator('id_empresa', this.servicio, this, 'acEmpresa', true, EnumOperator.Equals, [0]),
            new FieldValidator('id_problematica', this.servicio, this, 'acProblematica', true, EnumOperator.Equals, [0])          

        ]
    }


    private CheckRequiredFields() {
        this.LoadRequiredFields();
        return this.utilsSrv.RequiredFields(this.requiredFields);
    }

    private CheckRequiredFieldsTipoAtencion() {
        this.LoadRequiredFieldsTipoAtencion();
        return this.utilsSrv.RequiredFields(this.requiredFieldsTipoAtencion);
    }

         /*  Validador   */
    private CheckRequiredFieldsOrientacion() {
        this.requiredFieldsOrientacion = [           
            new FieldValidator('calle', this.servicioUbicacion, this, 'calle', true, EnumOperator.Equals, ['']),
            new FieldValidator('entrecalles', this.servicioUbicacion, this, 'entreCalles', true, EnumOperator.Equals, ['']),
            new FieldValidator('colonia', this.servicioUbicacion, this, 'colonia', true, EnumOperator.Equals, ['']),
            new FieldValidator('id', this.municipioUbicacionSelected, this, 'acMunicipioUbicacion', true),
            new FieldValidator('nombre', this.lesionado, this, 'Nombre', true, EnumOperator.Equals, ['']),
            new FieldValidator('riesgo', this.antecedente, this, 'riesgo', true)
        ]

        return this.utilsSrv.RequiredFields(this.requiredFieldsOrientacion);

    }


    public SetExterior(event : any){
        this.servicioUbicacion.exterior = event;
        this.LimpiaCoordenadas();
    }

    private LimpiaCoordenadas() {
        if (this.limpiaCoordenadas) {
            this.servicioUbicacion.latitud = 0;
            this.servicioUbicacion.longitud = 0;
            this.strCoordenadas = "0, 0";
        }
    }

    public CalleChange(ev) {
        this.servicioUbicacion.calle = ev;
        this.LimpiaCoordenadas();
    }

    public ColoniaChange(ev) {
        this.servicioUbicacion.colonia = ev;
        this.LimpiaCoordenadas();
    }

    public MunicipioUbicacionChange(ev) {
        this.municipioUbicacionSelected = ev;
        this.LimpiaCoordenadas();
    }

    public SetSexo(serv, value) {
        serv.id_sexo = value;
        this.servicio.id_sexo = this.listadoServicio[0].id_sexo;
    }

    public SetEdad(serv, value) {
        serv.edad = value;
        this.servicio.edad = this.listadoServicio[0].edad;
    }

    public SetEdadMeses(serv, value) {
        serv.meses = value;
        this.servicio.meses = this.listadoServicio[0].meses;
    }

    public SetBackground(id, prioridad, add){
        let element = document.getElementById(id);

        if(prioridad.id_prioridad == this.servicio.id_prioridad){
            return;
        }
        
        if(add){
            element.style.backgroundColor = "#" + prioridad.color_etiqueta;
            element.style.color = "#" + prioridad.color_texto;
        }else{
            element.style.backgroundColor = '';
            element.style.color = "#" + prioridad.color_etiqueta
        }

    }
    public SetBackgroundAntecedente(id, prioridad, add){
        let element = document.getElementById(id);

        if(prioridad.id_prioridad == this.lesionado.id_prioridad){
            return;
        }
        
        if(add){
            element.style.backgroundColor = "#" + prioridad.color_etiqueta;
            element.style.color = "#" + prioridad.color_texto;
        }else{
            element.style.backgroundColor = '';
            element.style.color = "#" + prioridad.color_etiqueta
        }

    }

    //Permisos
    _getPermisos(id_permiso : number) : Observable<any>{
        
        return this.connSvc.postAPI('Seguridad', 'GetPermisoVista', {id_perfil : this._id_perfil, id_permiso : id_permiso})
        .pipe(
            map(res => res.success ? res.response : throwError(res.message), catchError(error => throwError(error.error.message)))
        )
    }
}